const useDebounce = () => {

	let timeout = null;

	return function ( callback, delay) {

		clearTimeout(timeout);

		timeout = setTimeout(() => {
			 callback();
		}, delay || 500);
	};
}

export default useDebounce;